module.exports = __webpack_public_path__ + "img/spinner.f603a322.svg";